export default __webpack_public_path__ + "static/media/copmany-doc-1.88115946.jpg";